import script from "./DisclaimerBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./DisclaimerBlock.vue?vue&type=script&setup=true&lang=js"

import "./DisclaimerBlock.vue?vue&type=style&index=0&id=f62226b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f62226b8"]])

export default __exports__